export const remCalc = (px, base = 16) => {
	const tempPx = `${px}`.replace('px', '')

	return (1 / base) * parseInt(tempPx) + 'rem'
}
